module.exports = __webpack_public_path__ + "img/performance-hover.faa249fd.svg";